var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAdWordsDefault = function SvgAdWordsDefault(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FABC05",
    d: "M11.9249261,25.4432354 L1.27476282,7.69958253 C-0.195717878,5.24969531 0.668633629,2.11241032 3.20534594,0.692260373 C5.74205826,-0.727889574 8.99053003,0.106877418 10.4610107,2.55676463 L21.111174,20.3004175 C22.5816547,22.7503047 13.3954068,27.8931226 11.9249261,25.4432354 Z",
    transform: "matrix(-1 0 0 1 21.828 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.333,
    cy: 22.75,
    fill: "#34A852",
    rx: 5.333,
    ry: 5.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B8BD9",
    d: "M22.0496567,25.4432354 L11.384472,7.69958253 C9.91191733,5.24969531 10.777488,2.11241032 13.3177781,0.692260373 C15.8580683,-0.727889574 19.1111219,0.106877418 20.5836766,2.55676463 L31.2488613,20.3004175 C32.721416,22.7503047 31.8558454,25.8875897 29.3155552,27.3077396 C26.775265,28.7278896 23.5222115,27.8931226 22.0496567,25.4432354 Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdWordsDefault, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AdWordsDefault.42dc8f47.svg";
export { ForwardRef as ReactComponent };